const TIME_PATTERN = /^([0-1]?\d|2[0-3]):([0-5]\d)$/;

const parseTime = (value) => {
  if (!TIME_PATTERN.test(value || '')) return null;
  const [hours, minutes] = value.split(':').map(Number);
  return (hours * 60) + minutes;
};

export const formatDurationMinutes = (totalMinutes) => {
  if (!Number.isFinite(totalMinutes) || totalMinutes < 0) return '';
  const totalDays = Math.floor(totalMinutes / 1440);
  const months = Math.floor(totalDays / 30);
  const days = totalDays % 30;
  const remaining = totalMinutes % 1440;
  const hours = Math.floor(remaining / 60);
  const minutes = remaining % 60;
  const parts = [];
  if (months > 0) parts.push(`${months}mo`);
  if (days > 0) parts.push(`${days}d`);
  if (hours > 0) parts.push(`${hours}hr`);
  if (minutes > 0 || parts.length === 0) parts.push(`${minutes}min`);
  return parts.join(' ');
};

export const calculateClockDuration = (entryTime, exitTime) => {
  const entryMinutes = parseTime(entryTime);
  const exitMinutes = parseTime(exitTime);
  if (entryMinutes === null || exitMinutes === null) return '';
  let difference = exitMinutes - entryMinutes;
  if (difference < 0) difference += 1440;
  return formatDurationMinutes(difference);
};

export const calculateDatedDuration = (entryDate, entryTime, exitDate, exitTime) => {
  if (!entryDate || !exitDate) return '';
  const entryMinutes = parseTime(entryTime);
  const exitMinutes = parseTime(exitTime);
  if (entryMinutes === null || exitMinutes === null) return '';
  const [entryYear, entryMonth, entryDay] = entryDate.split('-').map(Number);
  const [exitYear, exitMonth, exitDay] = exitDate.split('-').map(Number);
  if (![entryYear, entryMonth, entryDay, exitYear, exitMonth, exitDay].every(Number.isFinite)) return '';
  const entry = new Date(entryYear, entryMonth - 1, entryDay, 0, entryMinutes);
  const exit = new Date(exitYear, exitMonth - 1, exitDay, 0, exitMinutes);
  const difference = Math.floor((exit.getTime() - entry.getTime()) / 60000);
  return difference >= 0 ? formatDurationMinutes(difference) : '';
};

const dateFromParts = (year, month, day) => {
  if (!year || !month || !day) return '';
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
};

export const getEntryDuration = (entry = {}) => {
  const savedDuration = String(entry.duration || '').trim();
  if (savedDuration && savedDuration.toLowerCase() !== 'n/a') return savedDuration;
  if (entry.tradingStyle === 'swing') {
    const entryDate = dateFromParts(entry.entryYear || entry.year, entry.entryMonth || entry.month, entry.entryDay || entry.day);
    const exitDate = dateFromParts(entry.exitYear, entry.exitMonth, entry.exitDay);
    const datedDuration = calculateDatedDuration(entryDate, entry.entryTime, exitDate, entry.exitTime);
    if (datedDuration) return datedDuration;
  }
  return calculateClockDuration(entry.entryTime, entry.exitTime);
};
